import { TrustLabelPeriod } from '../../../../../components-library/labels/TrustLabel';

export default {
  labels: {
    [TrustLabelPeriod.LESS_THAN_1_MONTH]: 'Peste +100 de clienți au comandat deja în siguranță la noi',
    [TrustLabelPeriod.ONE_MONTH_OR_MORE]: 'Peste +1.000 de clienți au comandat deja în siguranță la noi',
    [TrustLabelPeriod.SIX_MONTHS_OR_MORE]: 'Peste +10.000 de clienți au comandat deja în siguranță la noi',
  },
};
